import { entriesReducerFactory } from '@/fleet-configuration/data-fleet/entries/entries-reducer-factory'
import { SET_DEVICE, REMOVE_ALL_DEVICES, REMOVE_DEVICE_ENTRY, DEVICES_LOADED } from './devices-actions.js'

export const devicesReducer = entriesReducerFactory(SET_DEVICE, REMOVE_ALL_DEVICES, REMOVE_DEVICE_ENTRY, DEVICES_LOADED)
